<template>
  <div class="ao__tiktok-container" v-if="embed" v-html="embed"></div>
</template>

<script setup lang="ts">

import loadEmbedScript from "~/server/utils/request/loadEmbedScript";

const {payload} = defineProps < {
  payload? : any
} > ()

const getSrc = () => {
  return payload.attributes.src
}

if (window) {
  loadEmbedScript("tiktok", "https://www.tiktok.com/embed.js", {}, () => {console.log("emby")})
}

const embed = ref(null)

const {data, error} = await useFetch(`https://www.tiktok.com/oembed?url=` + getSrc())

if (!error.value && data) {
  embed.value = data.value.html
}

</script>
<style lang="postcss" scoped>
</style>
